// extracted by mini-css-extract-plugin
export default {"print_header":"style_print_header__pa9zX","sign":"style_sign__EeCE4"};